export default "__VITE_ASSET__DJzPXSCO__"